import React, { useMemo } from "react"

import wim from "../images/partners/logo_WIM.png"
import rse from "../images/partners/logo_RSE.png"
import terravitis from "../images/partners/terravitis.png"
import hve from "../images/partners/hve_coul.png"
import recyclage from "../images/partners/recyclage.png"
import paysOC from "../images/partners/logo_pays_oc.png"
import vignoblesDecouvertes from "../images/partners/vignoble_et_decouvertes.png"
import regionOccitanie from "../images/partners/region_occitanie.png"
import vignoblesOccitanie from "../images/partners/vignoble_occitanie.png"

import facebook from "../images/footer/facebook.svg"
import instagram from "../images/footer/instagram.svg"
import label_eco_concu from "../images/footer/label_eco_concu.png"
import linkedin from "../images/footer/linkedin.svg"
import twitter from "../images/footer/twitter.svg"

export default function Footer({ lang }) {
  const alcoholMessage = useMemo(() => {
    return lang === "fr" ? (
      <div className="alcohol-prevention">
        <span>
          L'ABUS D'ALCOOL EST DANGEREUX POUR LA SANTÉ. À CONSOMMER AVEC
          MODÉRATION.
        </span>
        <span>
          L'ALCOOL NE DOIT PAS ÊTRE CONSOMMÉ DURANT LA GROSSESSE. IL EST
          INTERDIT DE VENDRE DE L'ALCOOL AUX MINEURS.
        </span>
      </div>
    ) : (
      <div className="alcohol-prevention">
        <span>
          ALCOHOL ABUSE IS DANGEROUS FOR HEALTH. TO CONSUME WITH MODERATION.
        </span>
        <span>
          ALCOHOL SHOULD NOT BE CONSUMED DURING PREGNANCY. IT IS FORBIDDEN TO
          SELL ALCOHOL TO MINORS.
        </span>
      </div>
    )
  }, [lang])

  return (
    <footer>
      <div className="footer-container">
        <div className="container">
          <img
            src={label_eco_concu}
            id="label_eco_concu"
            alt="label eco concu"
          />
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <span className="footer-container-title">
                {lang === "fr" ? "NOUS CONTACTER" : "CONTACT US"}
              </span>
              <div className="footer-container-item-container">
                <span>BLB Vignobles</span>
                <span>Domaine de la Jasse</span>
                <span>F-34980 Combaillaux</span>
              </div>
              <div className="footer-container-item-container">
                <span>+33 4 67 67 04 04</span>
                <span>info@blb-vignobles.com</span>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <span className="footer-container-title">
                {lang === "fr" ? "AVIS" : "REVIEWS"}
              </span>
              <div
                className="vivino-widget vivino-wine-card-widget"
                data-vivino-widget-type="wine"
                data-vivino-vintage-id="4269174"
                data-vivino-user-id="50185460"
                data-vivino-widget-language="en"
                data-vivino-widget-featured-description="true"
                data-vivino-widget-layout="big"
              >
                <a
                  href="https://www.vivino.com/FR/fr/de-la-jasse-vieilles-vignes/w/1962620"
                  target="_blank"
                  rel="noreferrer"
                >
                  Domaine de la Jasse Vieilles Vignes on Vivino
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-12">
              <span className="footer-container-title">
                {lang === "fr" ? "SUIVEZ-NOUS" : "FOLLOW US"}
              </span>
              <div className="footer-container-item-container-logo">
                <a
                  href="https://www.facebook.com/blbvignobles/"
                  className="footer-container-item-container-logo-img"
                >
                  <img src={facebook} alt="facebook logo" />
                </a>
                <span>facebook</span>
              </div>
              <div className="footer-container-item-container-logo">
                <a
                  href="https://twitter.com/blb_vignobles/"
                  className="footer-container-item-container-logo-img"
                >
                  <img src={twitter} alt="twitter logo" />
                </a>
                <span>twitter</span>
              </div>
              <div className="footer-container-item-container-logo">
                <a
                  href="https://linkedin.com/company/blbvignobles/"
                  className="footer-container-item-container-logo-img"
                >
                  <img src={linkedin} alt="linkedin logo" />
                </a>
                <span>linkedin</span>
              </div>
              <div className="footer-container-item-container-logo">
                <a
                  href="https://www.instagram.com/blb_vignobles/"
                  className="footer-container-item-container-logo-img"
                >
                  <img src={instagram} alt="instagram logo" />
                </a>
                <span>instagram</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="partners">
        <img src={wim} alt="wine in moderation" />
        <img src={rse} alt="logo RSE" />
        <img src={terravitis} alt="terra vitis" />
        <img src={hve} alt="haute valeur environnementale" />
        <img src={recyclage} alt="recyclage" />
        <img src={paysOC} alt="pays d'oc" />
        <img
          src={vignoblesDecouvertes}
          alt="terres de garrigues et du pic saint-loup"
        />
        <img src={regionOccitanie} alt="region occitanie" />
        <img src={vignoblesOccitanie} alt="vignobles occitanie" />
      </div>
      {alcoholMessage}
      <div className="copyright">
        <span>
          &copy; 2020 - <b>BLB-Vignobles</b> -{" "}
          <a
            href="https://comonlight.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {lang === "fr" ? "Réalisation" : "Realization"} <b>ComOnLight</b>
          </a>{" "}
          -{" "}
          <a href={lang === "fr" ? `/fr/mentions-legales` : `/en/legal-notice`}>
            {lang === "fr" ? "MENTIONS LÉGALES" : "LEGAL NOTICE"}
          </a>
        </span>
      </div>
    </footer>
  )
}
